export default {
  MAIN: "/main",
  PRM_DETAILS: "/prm-details",
  PRM_UPDATE: "/prm-update",
  PRM_CREATE: "/prm-create",
  OPERATOR_DETAILS: "/operator-details",
  OPERATOR_ASSIGNMENT: "/operator-assignment"
};
